/* tslint:disable */
/* eslint-disable */
/**
 * Apperta Physical Health REST API
 * Apperta Physical Health REST API
 *
 * The version of the OpenAPI document: 0.2.0-SNAPSHOT2
 * Contact: info@staircase13.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProfileDto } from './ProfileDto';
import {
    ProfileDtoFromJSON,
    ProfileDtoFromJSONTyped,
    ProfileDtoToJSON,
} from './ProfileDto';

/**
 * Returns patient search results 
 * @export
 * @interface PatientSearchResponse
 */
export interface PatientSearchResponse {
    /**
     * Search terms which produced results
     * @type {{ [key: string]: string; }}
     * @memberof PatientSearchResponse
     */
    searchTerms?: { [key: string]: string; };
    /**
     * Paging page size
     * @type {number}
     * @memberof PatientSearchResponse
     */
    pageSize?: number;
    /**
     * Paging start record
     * @type {number}
     * @memberof PatientSearchResponse
     */
    start?: number;
    /**
     * Total number of patient profiles
     * @type {number}
     * @memberof PatientSearchResponse
     */
    total?: number;
    /**
     * Ordered by
     * @type {string}
     * @memberof PatientSearchResponse
     */
    orderTerm?: string;
    /**
     * Order direction
     * @type {string}
     * @memberof PatientSearchResponse
     */
    orderDirection?: string;
    /**
     * List of patient profiles
     * @type {Array<ProfileDto>}
     * @memberof PatientSearchResponse
     */
    profiles?: Array<ProfileDto>;
}

/**
 * Check if a given object implements the PatientSearchResponse interface.
 */
export function instanceOfPatientSearchResponse(value: object): value is PatientSearchResponse {
    return true;
}

export function PatientSearchResponseFromJSON(json: any): PatientSearchResponse {
    return PatientSearchResponseFromJSONTyped(json, false);
}

export function PatientSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'searchTerms': json['searchTerms'] == null ? undefined : json['searchTerms'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'start': json['start'] == null ? undefined : json['start'],
        'total': json['total'] == null ? undefined : json['total'],
        'orderTerm': json['orderTerm'] == null ? undefined : json['orderTerm'],
        'orderDirection': json['orderDirection'] == null ? undefined : json['orderDirection'],
        'profiles': json['profiles'] == null ? undefined : ((json['profiles'] as Array<any>).map(ProfileDtoFromJSON)),
    };
}

export function PatientSearchResponseToJSON(value?: PatientSearchResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'searchTerms': value['searchTerms'],
        'pageSize': value['pageSize'],
        'start': value['start'],
        'total': value['total'],
        'orderTerm': value['orderTerm'],
        'orderDirection': value['orderDirection'],
        'profiles': value['profiles'] == null ? undefined : ((value['profiles'] as Array<any>).map(ProfileDtoToJSON)),
    };
}

